import { Card, Grid, Dialog } from '@mui/material';
import { Box } from '@mui/system';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import RadioComponent from '../../components/formlib/RadioComponent';
import { FC, useState } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';

interface EditConfirmationModalForRecurringProps {
  showModal: boolean;
  closeModal: (selectedEvent: string | null) => void;
}
const EditConfirmationModalForRecurring: FC<
  EditConfirmationModalForRecurringProps
> = ({ showModal, closeModal }) => {
  const [error, setError] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<string | null>(null);

  return (
    <Dialog
      open={showModal}
      onClose={() => {
        setSelectedEvent(null);
        closeModal(null);
      }}
      fullWidth
      maxWidth="xs"
    >
      <Card
        sx={{
          padding: '24px',
        }}
      >
        <Box>
          <MediumTypography
            textColor="var(--thom-green-primary)"
            className="mainText-lg"
            labelid="updateRecurringEventsText"
            defaultlabel="Update Recurring Events?"
          />
          <Grid item xs={4.5}>
            <Box className="radiobtn mt-xs">
              <RadioComponent
                value={selectedEvent}
                name="deleteRecurringEvent"
                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSelectedEvent(e.target.value);
                  setError(false);
                }}
                labelidA="AddNewSchedulerEvent.DeleteThisOccuringEventLabel"
                defaultlabelidA="This Event"
                valueA="this"
                labelidB="AddNewSchedulerEvent.DeleteAlleOccuringEventLabel"
                defaultlabelidB="This and following Events"
                valueB="this_and_following"
              />
              {error && (
                <MediumTypography
                  className="mt-xs"
                  textColor="var(--thom-red)"
                  labelid="DeleteSchedulerEvent.validationErrorMessage"
                  defaultlabel="Please select an option"
                />
              )}
            </Box>
          </Grid>

          <Grid
            container
            direction="row"
            alignItems="right"
            textAlign={'right'}
          >
            <Grid item xs={12} textAlign={'right'}>
              <Grid mt={2}>
                <ButtonComponent
                  className="btn-primary btn-cancel"
                  variantType="contained"
                  labelId={'AddNewSchedulerEvent.cancelButton'}
                  defaultLabelId={'Cancel'}
                  onClick={() => {
                    setSelectedEvent(null);
                    closeModal(null);
                  }}
                />
                <ButtonComponent
                  variantType="contained"
                  type="submit"
                  className="btn-primary btn-submit ml-md"
                  labelId={'DuplicateClientModal.yesButton'}
                  defaultLabelId={'Yes'}
                  onClick={() => {
                    if (selectedEvent) {
                      setSelectedEvent(null);
                      closeModal(selectedEvent);
                    } else {
                      setError(true);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Dialog>
  );
};

export default EditConfirmationModalForRecurring;
